export const SYSTEM_MESSAGE_USER_NAME = 'devart';
// WixChatListEntry's have class-level getters for their "properties"
export const isWixChatListEntry = (p)=>{
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(p), 'id');
    return descriptor !== undefined && descriptor['get'] !== undefined;
};
export const isWixChatroom = (p)=>{
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(p), 'id');
    return descriptor !== undefined && descriptor['get'] === undefined;
};
export var ChatServiceStatus = /*#__PURE__*/ function(ChatServiceStatus) {
    ChatServiceStatus["ONLINE"] = "online";
    ChatServiceStatus["OFFLINE"] = "offline";
    ChatServiceStatus["STARTUP"] = "startup";
    return ChatServiceStatus;
}({});
export var ChatPageType = /*#__PURE__*/ function(ChatPageType) {
    ChatPageType["OVERLAY"] = "overlay";
    ChatPageType["FULLPAGE"] = "fullpage";
    return ChatPageType;
}({});
export var ChatParticipantDisplayDataTypes = /*#__PURE__*/ function(ChatParticipantDisplayDataTypes) {
    ChatParticipantDisplayDataTypes["ROOM"] = "room";
    ChatParticipantDisplayDataTypes["USER"] = "user";
    ChatParticipantDisplayDataTypes["MULTI"] = "multichat";
    return ChatParticipantDisplayDataTypes;
}({});
export var ChatLabels = /*#__PURE__*/ function(ChatLabels) {
    ChatLabels["ACTIVE"] = "42bfc914-8ae3-4525-8b49-32236b824b19";
    ChatLabels["REQUESTS"] = "7eeeb607-2a32-46e1-b71d-480e4c0b8c3c";
    ChatLabels["DEVIATION"] = "f84b38ba-a32c-4dc6-bc76-4a7585fa7995";
    ChatLabels["GROUP"] = "af06db63-fafc-4c86-86f5-1f49a7e9610c";
    return ChatLabels;
}({});
export var ChatroomScrollEvent = /*#__PURE__*/ function(ChatroomScrollEvent) {
    /** Used when a user receives a new message */ ChatroomScrollEvent["NEW_MESSAGE"] = "new_message";
    /** Used when a user sends a message */ ChatroomScrollEvent["SEND_MESSAGE"] = "send_message";
    /** Used when another user in the room is typing */ ChatroomScrollEvent["TYPING_INDICATOR"] = "typing_indicator";
    /** Used when the chatroom initially opens */ ChatroomScrollEvent["INITIAL_OPEN"] = "initial_open";
    /** Used when the chatroom gets minimized and opened back up */ ChatroomScrollEvent["WINDOW_TOGGLE"] = "window_toggle";
    /** Used when we want to navigate back to the default chat view and restore the user's scroll position */ ChatroomScrollEvent["RESTORE_SCROLL_POSITION"] = "RESTORE_SCROLL_POSITION";
    /** Used when we display the media bar on the footer */ ChatroomScrollEvent["MEDIA_BAR"] = "media_bar";
    /** Used when we load more messages */ ChatroomScrollEvent["LOAD_MORE"] = "load_more";
    /** Used when the user focused the message input field */ ChatroomScrollEvent["EDITOR_FOCUS"] = "editor_focus";
    return ChatroomScrollEvent;
}({});
export var NewChatRequestStatus = /*#__PURE__*/ function(NewChatRequestStatus) {
    NewChatRequestStatus["PRESUBMIT"] = "presubmit";
    NewChatRequestStatus["INITIALIZING"] = "initializing";
    NewChatRequestStatus["CREATING"] = "creating";
    NewChatRequestStatus["ERROR"] = "error";
    return NewChatRequestStatus;
}({});
/**
 * We use this to determine where to pull new chat participants from for a new chat request
 */ export var NewChatRequestSource = /*#__PURE__*/ function(NewChatRequestSource) {
    /**
   * When requesting a chat with a single user given context from surrounding web page elements.
   * e.g.
   * - an "Open Chat" button on a user's profile
   * - an "Open Chat" button on a notification from a user
   */ NewChatRequestSource["CREATE_OR_OPEN_DM"] = "create_or_open_dm";
    /**
   * When converting a single-user chat to a multi-user chat.
   */ NewChatRequestSource["CREATE_GROUP_CHAT"] = "create_group_chat";
    /**
   * When creating a new chat from scratch with the new chat window
   */ NewChatRequestSource["NEW_CHAT_WINDOW"] = "new_chat_window";
    return NewChatRequestSource;
}({});
export var ChatListSubscriptionStatus = /*#__PURE__*/ function(ChatListSubscriptionStatus) {
    ChatListSubscriptionStatus["LOADING"] = "loading";
    ChatListSubscriptionStatus["LISTENING"] = "listening";
    ChatListSubscriptionStatus["ERROR"] = "error";
    ChatListSubscriptionStatus["NONE"] = "none";
    return ChatListSubscriptionStatus;
}({});
export var ChatWorkerStatus = /*#__PURE__*/ function(ChatWorkerStatus) {
    ChatWorkerStatus["ALIVE"] = "alive";
    ChatWorkerStatus["TERMINATED"] = "terminated";
    return ChatWorkerStatus;
}({});
export var ChatWorkerIdleStatus = /*#__PURE__*/ function(ChatWorkerIdleStatus) {
    ChatWorkerIdleStatus["BUSY"] = "busy";
    ChatWorkerIdleStatus["IDLE"] = "idle";
    ChatWorkerIdleStatus["WAKING"] = "waking";
    return ChatWorkerIdleStatus;
}({});
export var ChatServiceError = /*#__PURE__*/ function(ChatServiceError) {
    ChatServiceError["BROWSER"] = "unsuppored-browser";
    ChatServiceError["LOGOUT"] = "logged-out";
    ChatServiceError["AUTH"] = "auth-failed";
    ChatServiceError["NETWORK"] = "network-disconnectd";
    ChatServiceError["UNKNOWN"] = "unknown";
    return ChatServiceError;
}({});

//# sourceMappingURL=types.js.map